import React from 'react';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import classNames from 'classnames'
import { images } from '../../../../assets/image';
import { ColorPalette } from 'screens/addEditCustomScreen/widgetsCardData/descriptionWidgetCard/types';

const TitleWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    widgetParams,
    defaultPaddings,
  } = props;

  const getTextColor = () => {
    const { textColor } = props.widgetParams;

    if (textColor === ColorPalette.PRIMARY) {

      return styles.primaryTitle;

    } else if (textColor === ColorPalette.ON_SURFACE) {

      return styles.onSurfaceTitle;

    }
  }

  return (
    <div
      className={classNames([styles.TitleCard, getTextColor()])}
      style={defaultPaddings}
    >
      {widgetParams.text}
    </div>
  );
};

export default TitleWidget;
